import { AnyAction } from 'redux';
import { SET_CURRENCY_FORMAT } from '../constants';

export interface CurrencyFormatState {
  countryId: string;
  currencyId: string;
}

const defaultState: CurrencyFormatState = {
  countryId: '',
  currencyId: '',
};

export const currencyFormat = (
  state = defaultState,
  action: AnyAction
): CurrencyFormatState => {
  const { type, payload } = action;
  switch (type) {
    case SET_CURRENCY_FORMAT:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};
